<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="预约id" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['makeAppointmentId']" placeholder="请输入预约id"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="房间ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['roomId']" placeholder="请输入房间ID"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="患者ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['patientId']" placeholder="请输入患者ID"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="身份证" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['idCard']" placeholder="请输入身份证"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="男女" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['sex']" placeholder="请输入男女"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="年龄" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['age']" placeholder="请输入年龄" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="上次就诊时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['lastTime']" placeholder="请输入上次就诊时间"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="检查检验单-0，外观照片-1，病历/处方-2，其他-3" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['type']" placeholder="请输入检查检验单-0，外观照片-1，病历/处方-2，其他-3"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="其他描述" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['ortherDesc']" placeholder="请输入其他描述"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="疾病名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['diseaseDesc']" placeholder="请输入疾病名称"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="症状描述" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['systomsDesc']" placeholder="请输入症状描述"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="用药情况" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['medicineDesc']" placeholder="请输入用药情况"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['status']" placeholder="请输入状态" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="医生id" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['doctorId']" placeholder="请输入医生id"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="医院检查" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['hosDesc']" placeholder="请输入医院检查"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="患者姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['patientName']" placeholder="请输入患者姓名"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="患病时长" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['timeLength']" placeholder="请输入患病时长"></a-input>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'

  export default {
    name: 'PatientMedicalRecordsForm',
    components: {
      JFormContainer,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
validatorRules: {
},
        url: {
          add: "/patientMedicalRecords/patientMedicalRecords/add",
          edit: "/patientMedicalRecords/patientMedicalRecords/edit",
          queryById: "/patientMedicalRecords/patientMedicalRecords/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'makeAppointmentId','roomId','patientId','idCard','sex','age','lastTime','type','ortherDesc','diseaseDesc','systomsDesc','medicineDesc','status','doctorId','hosDesc','patientName','timeLength'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'makeAppointmentId','roomId','patientId','idCard','sex','age','lastTime','type','ortherDesc','diseaseDesc','systomsDesc','medicineDesc','status','doctorId','hosDesc','patientName','timeLength'))
      },
    }
  }
</script>